import { Link } from 'react-router-dom'
import { Button } from '../../components/common'

/**
 * Pagina informativa sul club Conero Garage
 */
export default function IlClub() {
  return (
    <div className="container mx-auto px-4 py-12">
      {/* Hero */}
      <header className="text-center max-w-3xl mx-auto mb-16">
        <div className="w-24 h-24 bg-gold rounded-full flex items-center justify-center mx-auto mb-6">
          <span className="text-night font-display text-4xl font-bold">CG</span>
        </div>
        <h1 className="font-display text-4xl md:text-5xl text-white mb-4">
          Club 4x4 <span className="text-gold">Conero Garage</span>
        </h1>
        <p className="text-xl text-gray-400">
          Appassionati di fuoristrada e buona cucina dal 2010
        </p>
      </header>

      {/* Chi siamo */}
      <section className="mb-20">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          <div>
            <h2 className="font-display text-3xl text-white mb-6">Chi Siamo</h2>
            <div className="space-y-4 text-gray-400 leading-relaxed">
              <p>
                Il <strong className="text-white">Conero Garage</strong> nasce nel 2010
                da un gruppo di amici con la passione per il fuoristrada e l'amore
                per la nostra terra: le Marche.
              </p>
              <p>
                Il nome viene dal <strong className="text-gold">Monte Conero</strong>,
                quel promontorio affacciato sull'Adriatico che rappresenta il cuore
                della nostra regione. Un simbolo di bellezza selvaggia e natura incontaminata.
              </p>
              <p>
                Organizziamo uscite, raid e raduni per esplorare le strade bianche,
                i sentieri e i percorsi più nascosti delle Marche (e non solo).
                Ma c'è una cosa che amiamo quanto guidare sui nostri mezzi:
                <strong className="text-gold"> fermarci a mangiare bene</strong>.
              </p>
              <p>
                È così che è nato <strong className="text-white">Conero Garage Approved</strong>:
                una guida ai locali che abbiamo scoperto e testato durante le nostre avventure.
                Posti veri, genuini, dove "si mangia bene" non è solo uno slogan.
              </p>
            </div>
          </div>
          <div className="relative">
            <div className="aspect-square bg-night-light rounded-2xl overflow-hidden border border-gray-800">
              <img
                src="/images/donazione-anffas.jpg"
                alt="Il team Conero Garage durante una donazione benefica"
                className="w-full h-full object-cover"
              />
            </div>
            {/* Badge decorativo */}
            <div className="absolute -bottom-4 -left-4 bg-gold text-night px-6 py-3 rounded-xl shadow-lg">
              <p className="font-display text-2xl">Est. 2010</p>
            </div>
          </div>
        </div>
      </section>

      {/* I nostri valori */}
      <section className="mb-20 bg-night-light rounded-2xl p-8 md:p-12">
        <h2 className="font-display text-3xl text-white text-center mb-12">
          I Nostri Valori
        </h2>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          <div className="text-center">
            <div className="w-16 h-16 bg-gold/10 rounded-full flex items-center justify-center mx-auto mb-4">
              <svg className="w-8 h-8 text-gold" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z" />
              </svg>
            </div>
            <h3 className="font-display text-xl text-white mb-2">Amicizia</h3>
            <p className="text-gray-400 text-sm">
              Prima di tutto siamo un gruppo di amici. Le uscite sono occasioni
              per stare insieme, condividere esperienze e creare ricordi.
            </p>
          </div>
          <div className="text-center">
            <div className="w-16 h-16 bg-gold/10 rounded-full flex items-center justify-center mx-auto mb-4">
              <svg className="w-8 h-8 text-gold" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3.055 11H5a2 2 0 012 2v1a2 2 0 002 2 2 2 0 012 2v2.945M8 3.935V5.5A2.5 2.5 0 0010.5 8h.5a2 2 0 012 2 2 2 0 104 0 2 2 0 012-2h1.064M15 20.488V18a2 2 0 012-2h3.064M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
              </svg>
            </div>
            <h3 className="font-display text-xl text-white mb-2">Territorio</h3>
            <p className="text-gray-400 text-sm">
              Amiamo le Marche e vogliamo farle conoscere. Ogni uscita è
              un'occasione per scoprire angoli nascosti della nostra regione.
            </p>
          </div>
          <div className="text-center">
            <div className="w-16 h-16 bg-gold/10 rounded-full flex items-center justify-center mx-auto mb-4">
              <svg className="w-8 h-8 text-gold" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z" />
              </svg>
            </div>
            <h3 className="font-display text-xl text-white mb-2">Autenticità</h3>
            <p className="text-gray-400 text-sm">
              Cerchiamo l'autenticità in tutto: nei percorsi, nei locali,
              nelle persone. Niente fronzoli, solo sostanza.
            </p>
          </div>
        </div>
      </section>

      {/* Le nostre attività */}
      <section className="mb-20">
        <h2 className="font-display text-3xl text-white text-center mb-12">
          Le Nostre Attività
        </h2>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 max-w-4xl mx-auto">
          <div className="bg-night-light rounded-xl p-6 border border-gray-800 flex gap-4">
            <div className="w-12 h-12 bg-gold/10 rounded-lg flex items-center justify-center flex-shrink-0">
              <svg className="w-6 h-6 text-gold" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 20l-5.447-2.724A1 1 0 013 16.382V5.618a1 1 0 011.447-.894L9 7m0 13l6-3m-6 3V7m6 10l4.553 2.276A1 1 0 0021 18.382V7.618a1 1 0 00-.553-.894L15 4m0 13V4m0 0L9 7" />
              </svg>
            </div>
            <div>
              <h3 className="font-display text-lg text-white mb-1">Uscite Giornaliere</h3>
              <p className="text-gray-400 text-sm">
                Escursioni di una giornata per esplorare le colline marchigiane,
                con sosta pranzo in un locale approvato.
              </p>
            </div>
          </div>

          <div className="bg-night-light rounded-xl p-6 border border-gray-800 flex gap-4">
            <div className="w-12 h-12 bg-gold/10 rounded-lg flex items-center justify-center flex-shrink-0">
              <svg className="w-6 h-6 text-gold" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
              </svg>
            </div>
            <div>
              <h3 className="font-display text-lg text-white mb-1">Raid e Weekend</h3>
              <p className="text-gray-400 text-sm">
                Avventure di più giorni per spingerci oltre i confini regionali
                e scoprire nuovi territori.
              </p>
            </div>
          </div>

          <div className="bg-night-light rounded-xl p-6 border border-gray-800 flex gap-4">
            <div className="w-12 h-12 bg-gold/10 rounded-lg flex items-center justify-center flex-shrink-0">
              <svg className="w-6 h-6 text-gold" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0z" />
              </svg>
            </div>
            <div>
              <h3 className="font-display text-lg text-white mb-1">Raduni</h3>
              <p className="text-gray-400 text-sm">
                Eventi annuali dove incontriamo altri club e appassionati
                da tutta Italia.
              </p>
            </div>
          </div>

          <div className="bg-night-light rounded-xl p-6 border border-gold/30 flex gap-4">
            <div className="w-12 h-12 bg-gold/20 rounded-lg flex items-center justify-center flex-shrink-0">
              <svg className="w-6 h-6 text-gold" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 6.253v13m0-13C10.832 5.477 9.246 5 7.5 5S4.168 5.477 3 6.253v13C4.168 18.477 5.754 18 7.5 18s3.332.477 4.5 1.253m0-13C13.168 5.477 14.754 5 16.5 5c1.747 0 3.332.477 4.5 1.253v13C19.832 18.477 18.247 18 16.5 18c-1.746 0-3.332.477-4.5 1.253" />
              </svg>
            </div>
            <div>
              <h3 className="font-display text-lg text-gold mb-1">Conero Garage Approved</h3>
              <p className="text-gray-400 text-sm">
                La nostra guida ai migliori locali dove mangiare, frutto di
                anni di esplorazioni gastronomiche.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Contatti */}
      <section className="bg-gold/10 border border-gold/30 rounded-2xl p-8 md:p-12 text-center max-w-3xl mx-auto">
        <h2 className="font-display text-3xl text-white mb-4">
          Vuoi Saperne di Più?
        </h2>
        <p className="text-gray-400 mb-8">
          Seguici sui social per restare aggiornato sulle nostre attività,
          o contattaci per qualsiasi informazione.
        </p>

        {/* Social links */}
        <div className="flex justify-center gap-4 mb-8">
          <a
            href="https://instagram.com/conerogarage"
            target="_blank"
            rel="noopener noreferrer"
            className="w-12 h-12 bg-night rounded-full flex items-center justify-center text-gray-400 hover:text-gold hover:bg-night-light transition-colors"
          >
            <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 24 24">
              <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073z"/>
            </svg>
          </a>
          <a
            href="https://facebook.com/conerogarage"
            target="_blank"
            rel="noopener noreferrer"
            className="w-12 h-12 bg-night rounded-full flex items-center justify-center text-gray-400 hover:text-gold hover:bg-night-light transition-colors"
          >
            <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 24 24">
              <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/>
            </svg>
          </a>
          <a
            href="mailto:info@conerogarage.it"
            className="w-12 h-12 bg-night rounded-full flex items-center justify-center text-gray-400 hover:text-gold hover:bg-night-light transition-colors"
          >
            <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
            </svg>
          </a>
        </div>

        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <a href="https://conerogarage.it" target="_blank" rel="noopener noreferrer">
            <Button variant="primary">
              Sito del Club
            </Button>
          </a>
          <Link to="/locali">
            <Button variant="secondary">
              Esplora i locali
            </Button>
          </Link>
        </div>
      </section>
    </div>
  )
}
